import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconChevronUp = forwardRef<SVGSVGElement, IconProps>(
  function IconChevronUp(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M3.70087 20.2473L15.7009 9.64725C15.8118 9.55087 15.9539 9.49779 16.1009 9.49779C16.2479 9.49779 16.3899 9.55087 16.5009 9.64725L28.5009 20.2473C28.5602 20.2996 28.6086 20.3632 28.6432 20.4344C28.6779 20.5055 28.6981 20.5828 28.7028 20.6618C28.7074 20.7409 28.6964 20.82 28.6703 20.8947C28.6442 20.9694 28.6037 21.0383 28.5509 21.0973C28.4437 21.2148 28.2948 21.2857 28.136 21.2951C27.9773 21.3044 27.8211 21.2514 27.7009 21.1473L16.1009 10.8973L4.50087 21.1473C4.38063 21.2514 4.22448 21.3044 4.0657 21.2951C3.90692 21.2857 3.75806 21.2148 3.65087 21.0973C3.59808 21.0383 3.55748 20.9695 3.53141 20.8947C3.50534 20.82 3.49431 20.7409 3.49896 20.6618C3.50361 20.5828 3.52384 20.5055 3.55849 20.4344C3.59315 20.3632 3.64153 20.2996 3.70087 20.2473Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
